import { globs } from "../globs";
import {
	ActionScope,
	Any, 
	Pattern 
} from "./actionScopes";

const canReadAnyTypeGlob = globs.entityTypes.byType("*").read;

export const isAnyTypeReadPermittedScope = (): ActionScope => {
	const canReadAnyTypePattern = new Pattern(canReadAnyTypeGlob);

	const canAnySubjectReadTypeGlob = globs.subjects.byType("*").assigned.byType("*").read;
	const canAnySubjectReadTypePattern = new Pattern(canAnySubjectReadTypeGlob);

	const anyTypeScope = new Any([canReadAnyTypePattern, canAnySubjectReadTypePattern]);

	return anyTypeScope;
};

export const isTypeReadPermittedScope = (typeCode: string): ActionScope => {
	const canReadTypeGlob = globs.entityTypes.byType(typeCode).read;
	const canReadTypePattern = new Pattern(canReadTypeGlob);

	const canAnySubjectReadTypeGlob = globs.subjects.byType("*").assigned.byType(typeCode).read;
	const canAnySubjectReadTypePattern = new Pattern(canAnySubjectReadTypeGlob);

	const typeScope = new Any([canReadTypePattern, canAnySubjectReadTypePattern]);

	return typeScope;
};

// create, write
const canWriteAnyTypePropertyGlob = `${globs.entityTypes.byType("**").self}/write`;
const canCreateAnyTypePropertyGlob = `${globs.entityTypes.byType("**").self}/create`;
const canWriteAnyTypeGlob = globs.entityTypes.byType("*").write;
const canUpdateAnyTypeGlob = globs.entityTypes.byType("*").assign;

const canAnySubjectDoAction = (glob: string) => `/subjects/*/assigned${glob}`;

export const isAnyTypeWritePermittedScope = (): ActionScope => {
	const canWriteAnyTypePattern = new Pattern(canWriteAnyTypeGlob);
	const canWriteAnyTypePropertyPattern = new Pattern(canWriteAnyTypePropertyGlob);
	const canCreateAnyTypePropertyPattern = new Pattern(canCreateAnyTypePropertyGlob);
	const canUpdateAnyTypePattern = new Pattern(canUpdateAnyTypeGlob);

	const canAnySubjectWriteAnyTypePattern = new Pattern(canAnySubjectDoAction(canWriteAnyTypeGlob));
	const canAnySubjectWriteAnyTypePropertyPattern = new Pattern(canAnySubjectDoAction(canWriteAnyTypePropertyGlob));
	const canAnySubjectCreateAnyTypePropertyPattern = new Pattern(canAnySubjectDoAction(canCreateAnyTypePropertyGlob));
	const canAnySubjectUpdateAnyTypePattern = new Pattern(canAnySubjectDoAction(canUpdateAnyTypeGlob));

	const anyWriteScope = new Any([
		canWriteAnyTypePattern,
		canWriteAnyTypePropertyPattern,
		canCreateAnyTypePropertyPattern,
		canUpdateAnyTypePattern,
		canAnySubjectWriteAnyTypePattern,
		canAnySubjectWriteAnyTypePropertyPattern,
		canAnySubjectCreateAnyTypePropertyPattern,
		canAnySubjectUpdateAnyTypePattern
	]);

	return anyWriteScope;
};

export const isTypeWritePermittedScope = (typeCode: string): ActionScope => {
	const canWriteTypeGlob = globs.entityTypes.byType(typeCode).write;
	const canAssignTypeGlob = globs.entityTypes.byType(typeCode).assign;
	const canWriteTypePropertyGlob = `${globs.entityTypes.byType(typeCode).self}/**/write`;
	const canCreateTypePropertyGlob = `${globs.entityTypes.byType(typeCode).self}/**/create`;

	const canWriteTypePattern = new Pattern(canWriteTypeGlob);
	const canAssignTypePattern = new Pattern(canAssignTypeGlob);
	const canWriteTypePropertyPattern = new Pattern(canWriteTypePropertyGlob);
	const canCreateTypePropertyPattern = new Pattern(canCreateTypePropertyGlob);

	const canAnySubjectWriteTypePattern = new Pattern(canAnySubjectDoAction(canWriteTypeGlob));
	const canAnySubjectAssignTypePattern = new Pattern(canAnySubjectDoAction(canAssignTypeGlob));
	const canAnySubjectWriteTypePropertyPattern = new Pattern(canAnySubjectDoAction(canWriteTypePropertyGlob));
	const canAnySubjectCreateTypePropertyPattern = new Pattern(canAnySubjectDoAction(canCreateTypePropertyGlob));


	const typeScope = new Any([
		canWriteTypePattern, 
		canAssignTypePattern, 
		canAnySubjectAssignTypePattern,
		canAnySubjectWriteTypePattern,
		canWriteTypePropertyPattern,
		canCreateTypePropertyPattern,
		canAnySubjectWriteTypePropertyPattern,
		canAnySubjectCreateTypePropertyPattern
	]);

	return typeScope;
};